import { useFiltersContext } from "../../../../Filters/hooks/useFiltersContext";
import { useChartsData } from "../../../../hooks/useChartsData";

export const useCityServices = (queryConfig) => {
    const { filters } = useFiltersContext();
    
    const { data, isLoading, isError } = useChartsData(
        {
            key: queryConfig.key,
            url: queryConfig.url,
        },
        {
            location: filters.unidade.value,
            year: filters.ano?.value,
            month: filters.competencia?.value,
        }
    );

    const chartData = data
        ? {
              counterByCity: data?.counterByCity || []
          }
        : {
              counterByCity: []
          };

    return {
        chartData,
        isLoading,
        isError, 
        data
    };
};
